import React from 'react';

const HeatMapComponentLoadable = React.lazy(() => import('./HeatMapComponent'));
export {
    HeatMapComponentLoadable
};  